<!--
  navItem "Matrix-Zuordnung" — the DIM rule set that routes a contract onto a provision matrix,
  per commission component (04-frontend.md §6, entry 8).

  The table is the generic child table; the only addition is the pre-filter on the commission
  component that §6 asks for ("Vorfilter auf die gewählte Provisionsart als Bedien-Hilfe"). The
  pre-filter is a READ aid: it narrows the list, it does not change how rows are created — the
  create form still pre-fills the provision type and lets the user pick the component.
-->
<div class="cp-provision-type-matrix-assignment">

    @if (initialized && provisionTypeId) {

        @if (componentOptions.length) {
            <div class="flex align-items-center flex-wrap gap-2 mb-3">
                <i class="fa-solid fa-filter text-color-secondary"></i>
                <label for="cpMatrixAssignmentComponentFilter" class="text-sm text-color-secondary">
                    Provisionsart
                </label>
                <p-select
                        inputId="cpMatrixAssignmentComponentFilter"
                        styleClass="w-16rem"
                        [options]="componentOptions"
                        optionLabel="name"
                        optionValue="id"
                        [ngModel]="selectedComponentId"
                        (ngModelChange)="onComponentChange($event)"
                        [showClear]="true"
                        placeholder="Alle Provisionsarten">
                </p-select>
                <span class="text-sm text-color-secondary">
                    Zeigt nur die Zuordnungen der gewählten Provisionsart — die vollständige Zeile
                    wird im Detail-Dialog gepflegt.
                </span>
            </div>
        }

        <cp-provision-type-child-table
                [provisionTypeId]="provisionTypeId"
                [child]="child"
                [additionalFilters]="additionalFilters"
                (onJumpToConditionSet)="onJumpToConditionSet.emit($event)">
        </cp-provision-type-child-table>

    } @else if (initialized) {
        <p-message severity="info" text="Kein Provisionstyp ausgewählt." styleClass="w-full"></p-message>
    } @else {
        <p-skeleton height="12rem"></p-skeleton>
    }

</div>
